<template>
    <div class="py-4 container-fluid">
        <form role="form" @submit.prevent="onSubmitForm()">
            <div class="row">
                <div class="col-xl-8 mt-xl-0">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-xl-12">
                                    <div class="form-group">
                                        <label for="name" class="form-label">Name</label>
                                        <input type="text" class="form-control" v-model="record.name" required>
                                    </div>
                                </div>
                                <div class="col-xl-12">
                                    <div class="form-group">
                                        <label for="signal" class="form-label">Signal Details</label>
                                        <quill-editor theme="snow" :options="options" v-model:content="record.details" contentType="html"></quill-editor>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6">
                                    <div class="form-group">
                                        <label for="set_time" class="form-label">Set Time</label>
                                        <select id="set_time" class="dataTable-selector form-select form-select-sm" v-model="record.send_now" required>
                                            <option :value="true" >Send Now</option>
                                            <option :value="false">Set Minute</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6">
                                    <div class="form-group">
                                        <label class="form-label">Send Signal After</label>
                                        <div class="input-group">
                                            <input type="number" class="form-control" v-model="record.send_minutes" :disabled="record.send_now">
                                            <span class="input-group-text">Minutes</span>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="col-12 col-sm-2">
                                    <div class="form-group">
                                        <label class="form-label" for="status">Status</label>
                                        <div class="form-check form-switch input-group">
                                            <input class="form-check-input" type="checkbox" id="status" v-model="record.status">
                                        </div>
                                    </div>
                                </div> -->
                                <div class="mt-4 d-flex justify-content-end">
                                    <a href="/broadcast-signal" class="m-0 btn btn-light">Cancel</a>
                                    <button
                                        type="submit"
                                        name="button"
                                        class="m-0 btn bg-gradient-success ms-2"
                                    >
                                        {{ submitButtonName }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 mt-xl-0 mt-3">
                    <div class="card">
                        <div class="card-header justify-content-between d-flex flex-wrap">
                            <h6 class="card-title">Selected Package For This Signal</h6>
                            <button class="btn btn-sm btn-outline-primary" type="button" @click="togglePackages">{{ allPackagesSelected ? 'Unselect All' : 'Select All' }}</button>
                        </div>
                        <div class="card-body packages pt-0">
                            <ol class="list-unstyled">
                                <div class="form-check">
                                    <li v-for="item in packages" :key="item.value">
                                        <input :id="item.value" type="checkbox" :name="'packages[]'" class="form-check-input" :value="item.value" v-model="record.selected_package">
                                        <label class="form-check-label" :for="item.value">{{ item.label }}</label>
                                    </li>
                                </div>
                            </ol>
                        </div>
                    </div>
                    <div class="card mt-3">
                        <div class="card-header justify-content-between d-flex flex-wrap">
                            <h6 class="card-title">Notification Send Via</h6>
                            <button class="btn btn-sm btn-outline-primary" type="button" @click="toggleSendVia">{{ allSendViaSelected ? 'Unselect All' : 'Select All' }}</button>
                        </div>
                        <div class="card-body via pt-0">
                            <ol class="list-unstyled">
                                <li v-for="(via) in sendViaOptions" :key="via.value">
                                    <div class="form-check">
                                        <input :id="via.value" type="checkbox" :name="'send_via[]'" class="form-check-input" :value="via.value" v-model="record.send_notif_via">
                                        <label :for="via.value" class="form-check-label">{{ via.label }}</label>
                                    </div>
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import { QuillEditor } from '@vueup/vue-quill';
import '@vueup/vue-quill/dist/vue-quill.snow.css';

export default {
    data() {
      return {
        record: {
            name: '',
            details: '',
            send_now: true,
            is_send_now: true,
            send_minutes: 0,
            status: true,
            selected_package: [],
            send_notif_via: []
        },
        packages: [
            { label: 'Silver', value: 'silver' },
            { label: 'Gold', value: 'gold' },
            { label: 'Platinum', value: 'platinum' }
        ],
        sendViaOptions: [
            { label: 'Email', value: 'email' },
            // { label: 'SMS', value: 'sms' },
            // { label: 'Telegram', value: 'telegram' },
            // { label: 'Push', value: 'push' }
        ],
      };
    },
    computed: {
        allPackagesSelected() {
            return this.record.selected_package.length === this.packages.length;
        },
        allSendViaSelected() {
            return this.record.send_notif_via.length === this.sendViaOptions.length;
        }
    },
    props: {
        submitButtonName: String,
        onSubmit: { type: Function },
        toggleModal: { type: Function },
        recordProps: { type: Object }
    },
    components: {
        QuillEditor
    },
    methods: {
        onSubmitForm() {
            this.onSubmit(this.record)
        },
        togglePackages() {
            if (this.allPackagesSelected) {
                this.record.selected_package = [];
            } else {
                this.record.selected_package = this.packages.map(pkg => pkg.value);
            }
        },
        toggleSendVia() {
            if (this.allSendViaSelected) {
                this.record.send_notif_via = [];
            } else {
                this.record.send_notif_via = this.sendViaOptions.map(option => option.value);
            }
        }
    },
    watch: {
        recordProps: function (newVal, oldVal) { 
            console.log('Prop changed: ', newVal, ' | was: ', oldVal)
            this.record = newVal
            this.record.send_now = newVal.is_send_now
        }
    },
    setup: () => {
      const options = {modules: {toolbar: false}}
      return { options }
    },
}
</script>

<style>
.form-check:not(.form-switch) .form-check-input[type=checkbox]:after {
    content: '\2713' !important;
}
</style>